import { Modal } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  disablePendencyByModal,
  findPendencyById,
  getAllPendings,
  resolvePendencyByModal,
  setPending,
  setPendingModal,
} from 'screens/Pendings/actions'
import { newPendingUpdate as updatePendings } from 'screens/LoadsDetails/actions'
import InfiniteScroll from 'react-infinite-scroll-component'
import BindDriverModal from 'screens/Pendings/components/BindDriverModal'
import Span from 'components/Span'
import cuid from 'cuid'
import get from 'lodash.get'
import css from './index.scss'
import styles from '../PendingsList/index.scss'
import { PendingTag } from '../PendingCard'
import PendencieActionDrawer from '../PendingActionDrawer'
import ConfirmationModal from '../ConfirmationModal'
import DeliverConfirmModal from '../DeliverConfirmModal'
import { confirmationModalState } from 'screens/Pendings/utils'

const actionDrawerInitialState = { visible: false, selectedPending: null }

const PendingCard = ({ pending, onCancel, bullet, onResolvePending }) => {
  if (!pending) return null

  return (
    <div className={css.cardWrapper}>
      {(bullet || !pending.viewed) && <div className={css.bullet} />}
      <div className={css.cardContainer}>
        <PendingTag pending={pending} />
        <div className="column" style={{ minWidth: 350, width: 350 }}>
          <Span
            className={css.title}
            text={pending.pendingType?.name || 'n/a'}
          />
          <Span className={css.subtitle} text={pending.externalId || 'n/a'} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            color: '#fff',
          }}
        >
          <button className={css.resolveBtn} onClick={onResolvePending}>
            Resolver
          </button>
        </div>
      </div>
    </div>
  )
}

const PendingModal = ({ location }) => {
  const [actionDrawerConfigs, setActionDrawerConfigs] = useState({
    ...actionDrawerInitialState,
  })
  const [confirmationModal, setConfirmationModal] = useState({
    ...confirmationModalState,
  })
  const [disposeModal, setDisposeModal] = useState({
    ...confirmationModalState,
  })
  const pendingsForModal = useSelector((state) =>
    get(state, 'pendings.list', []),
  ).filter((p) => p.status === 'OPEN')

  const targetType = 'TRANSPORTER'
  const length = pendingsForModal.length
  const firstPending = pendingsForModal[0]

  const dispatch = useDispatch()
  const setVisible = (v) => dispatch(setPendingModal(v))
  const selectedPending = useSelector((state) => state.pendings.selectedPending)
  const newPendingUpdate = useSelector(
    (state) => state.loadsDetails.newPendingUpdate,
  )
  const isVisible = useSelector((state) => state.pendings.pendingModal.visible)
  const type = useSelector((state) => state.pendings.pendingModal.type)
  const newUpdate = useSelector(
    (state) => state.pendings.pendingModal.newUpdate,
  )
  const modalPage = useSelector((state) => state.pendings.page)
  const modalHasMore = useSelector((state) => state.pendings.hasMore)

  const containerRef = useRef(cuid())

  const modalShownToday =
    localStorage.getItem('pendingModal') === new Date().toLocaleDateString()

  const onCancel = () => {
    localStorage.setItem('pendingModal', new Date().toLocaleDateString())
    setVisible({ visible: false, type: null })
    dispatch(updatePendings())
  }

  const onRemovePending = (pending) => {
    if (!pending) return
    setDisposeModal({
      visible: true,
      selectedPending: pending,
      theme: 'purple',
      observation: '',
    })
  }

  const onResolvePending = (pending) => {
    if (!pending) return
    setConfirmationModal({
      visible: true,
      selectedPending: pending,
      theme: 'purple',
      observation: '',
    })
  }

  const openActionDrawer = (item) => {
    setActionDrawerConfigs({ visible: true, selectedPending: item })
    dispatch(findPendencyById(item.id, targetType))
  }
  const closeActionDrawer = () => {
    setActionDrawerConfigs({ ...actionDrawerInitialState })
    dispatch(setPending(null))
  }

  const onCloseConfirmationModal = () => {
    setConfirmationModal({ ...confirmationModalState })
    closeActionDrawer()
  }
  const onCloseDisposeModal = () => {
    setDisposeModal({ ...confirmationModalState })
    closeActionDrawer()
  }

  const nextPage = () => {
    if (type === 'DETAIL') {
      dispatch(
        getAllPendings({
          status: 'OPEN',
          notViewed: true,
          page: modalPage + 1,
         targetType
        }),
      )
      return
    }
    dispatch(getAllPendings({ status: 'OPEN', page: modalPage + 1, targetType }))
  }

  const renderBindDriverModal = () => {
    if (!confirmationModal.selectedPending) return null
    const {
      selectedPending: {
        shippingHash,
        shippingDeliveryId,
        externalId,
        shippingType,
        pendingType,
      },
      visible,
    } = confirmationModal

    const load = {
      hashId: shippingHash,
      deliveryId: shippingDeliveryId,
      externalId,
      shippingType,
    }

    if (load && visible && pendingType?.type === 'REQUEST_ADD_DRIVER_VEHICLE') {
      return (
        <BindDriverModal load={load} onCloseClick={onCloseConfirmationModal} />
      )
    }
    document.body.style.overflow = 'auto'
    return null
  }

  const renderDeliverConfirmModal = () => {
    if (!confirmationModal.selectedPending) return null
    
    const {
      selectedPending: {
        shippingHash,
        shippingDeliveryId,
        externalId,
        shippingType,
        pendingType,
      },
      visible,
    } = confirmationModal

    const load = {
      hashId: shippingHash,
      deliveryId: shippingDeliveryId,
      externalId,
      shippingType,
    }
 
    if (load && visible && pendingType?.type === 'REQUEST_FINISH_DELIVERY')  {
      document.body.style.overflow = 'hidden'
      return (
        <DeliverConfirmModal
          onCloseClick={onCloseConfirmationModal}
          load={load}
          hashId={shippingHash}
          deliveryId={shippingDeliveryId}
          shippingType={shippingType}
        />
      )
    }
    document.body.style.overflow = 'auto'
    return null
  }

  useEffect(() => {
    dispatch(getAllPendings({ page: 1, status: 'OPEN',targetType: 'TRANSPORTER' }))
  }, [])

  useEffect(() => {
    if (type === 'DETAIL') {
      dispatch(getAllPendings({ status: 'OPEN', notViewed: true, page: 1,targetType }))
    }
  }, [type, newUpdate])

  useEffect(() => {
    if (
      !modalShownToday &&
      !location.pathname?.includes('/pendings') &&
      !location.pathname?.includes('/details')
    ) {
      dispatch(getAllPendings({ status: 'OPEN', page: 1,targetType }))
    }
  }, [modalShownToday, dispatch])

  useEffect(() => {
    function showModal() {
      setVisible({ visible: true })
    }
    if (
      !modalShownToday &&
      length > 0 &&
      !isVisible &&
      !location.pathname?.includes('/pendings') &&
      !location.pathname?.includes('/details')
    ) {
      showModal()
    }
    if (
      length > 0 &&
      !isVisible &&
      type === 'DETAIL' &&
      !location.pathname?.includes('/pendings') &&
      !location.pathname?.includes('/details')
    ) {
      showModal()
    }
    if (
      (isVisible && location.pathname.includes('/pendings')) ||
      location.pathname.includes('details')
    ) {
      onCancel()
    }
    if (isVisible && !length) {
      onCancel()
    }
  }, [modalShownToday, location.pathname, length, type])

  useEffect(() => {
    if (newPendingUpdate?.type === 'CLOSE_PENDENCIES' && isVisible) {
      type === 'DETAIL'
        ? dispatch(getAllPendings({ status: 'OPEN', notViewed: true, page: 1,targetType }))
        : dispatch(getAllPendings({ page: 1, status: 'OPEN',targetType }))
    }
    if (newPendingUpdate?.type && isVisible && actionDrawerConfigs.visible) {
      dispatch(findPendencyById(selectedPending?.id, 'TRANSPORTER'))
    }
  }, [newPendingUpdate?.moment])

  return (
    <>
      <Modal
        footer={null}
        visible={isVisible}
        className={css.modal}
        closable={false}
        width={600}
        bodyStyle={{
          padding: 0,
          minHeight: 500,
        }}
        wrapClassName={css.wrap}
        zIndex={998}
      >
        {type === 'DETAIL' && firstPending ? (
          <div className={css.header}>Uma nova pendência foi aberta</div>
        ) : (
          <div className={css.header}>Pendências não visualizadas</div>
        )}

        <div className={css.body} id={containerRef.current}>
          <InfiniteScroll
            dataLength={pendingsForModal.length}
            hasMore={modalHasMore}
            next={nextPage}
            scrollableTarget={containerRef.current}
          >
            {!!pendingsForModal.length &&
              pendingsForModal.map((item) => (
                <PendingCard
                  pending={item}
                  onCancel={onCancel}
                  bullet={type === 'DETAIL'}
                  key={item.id}
                  onResolvePending={() => openActionDrawer(item)}
                />
              ))}
          </InfiniteScroll>
        </div>
        <div className={css.footer}>
          <button className={css.button} onClick={onCancel}>
            Fechar
          </button>
        </div>
      </Modal>
      {renderBindDriverModal()}
      {renderDeliverConfirmModal()}
      <PendencieActionDrawer
        pending={selectedPending || actionDrawerConfigs.selectedPending}
        visible={actionDrawerConfigs.visible}
        onClose={closeActionDrawer}
        onRemovePendency={onRemovePending}
        onResolvePendency={onResolvePending}
      />
      <ConfirmationModal
        antdModalProps={{
          visible: disposeModal.visible,
          onCancel: onCloseDisposeModal,
          okText: 'Descartar',
          cancelText: 'Fechar',
          okType: 'danger',
          onOk: () =>
            dispatch(
              disablePendencyByModal(
                {
                  id: disposeModal.selectedPending.id,
                  observation: disposeModal.observation,
                },
                onCloseDisposeModal,
                type === 'DETAIL'
                  ? { status: 'OPEN', notViewed: true, targetType }
                  : { status: 'OPEN', targetType },
              ),
            ),
          okButtonProps: {
            disabled: disposeModal.observation.length < 5,
          },
        }}
        title="Descartar Pendência"
        theme="red"
        content={
          disposeModal.selectedPending && (
            <div>
              <span className={styles.description}>
                {disposeModal.selectedPending?.pendingType?.hintToDispose}
              </span>
              <div className={styles.observationWrapper}>
                <label className={styles.label}>Observação</label>
                <textarea
                  placeholder="Adicione a observação"
                  value={disposeModal.observation}
                  onChange={(e) => {
                    e.persist()
                    setDisposeModal((p) => ({
                      ...p,
                      observation: e.target.value,
                    }))
                  }}
                  className={styles.textarea}
                />
              </div>
            </div>
          )
        }
      />
    </>
  )
}

export default withRouter(PendingModal)
